import { computed } from 'vue'
import { RouterLink } from 'vue-router'

import { createUiKit } from '@ui/utils/createUiKit'

export function createAppUiKit({ i18n, router } = {}) {
  const t = i18n?.global.t

  const messages = t && computed(() => ({
    pagination: {
      label: t('ui.pagination.label'),
      page: t('ui.pagination.page'),
      previous: t('ui.common.previous'),
      next: t('ui.common.next'),
      previousLabel: t('ui.pagination.prev_label'),
      nextLabel: t('ui.pagination.next_label'),
      firstLabel: t('ui.pagination.first_label'),
      lastLabel: t('ui.pagination.last_label'),
      goToLabel: (page) => t('ui.pagination.go_to_label', { pageNum: page }),
    },
    select: {
      empty: t('ui.app_select.empty_text'),
    },
    colorPicker: {
      selectColor: t('ui.common.select_color'),
    },
    emptyState: {
      retry: t('ui.common.retry'),
    },
    fileUploader: {
      chooseFile: t('ui.common.choose_file'),
      description: (formats, size) => t('ui.common.file_uploader_description', { f: formats, s: size }),
      invalidSize: (size) => t('ui.common.file_uploader_invalid_size', { s: size }),
      invalidFormat: t('ui.common.file_uploader_invalid_format'),
    },
    tree: {
      title: t('ui.products.collection'),
    },
  }))

  return createUiKit({
    messages,
    linkComponent: router ? RouterLink : undefined,
    navigate: router ? (to) => router.push(to) : undefined,
    imageFallback: '/images/no-image-found.svg',
  })
}
